<template>
  <v-card
    width="100%"
    max-width="420"
    text
    tile
    color="red lighten-4"
    class="ma-4"
  >
    <v-card-text class="text-xs-center">
      <div class="title error--text text--darken-1">Your accounts are not configured yet.</div>
      <div class="title error--text text--darken-1">Setup them now.</div>
      <v-btn
        small
        color="error"
        to="/admin/setup-accounts"
      >Setup</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'AdminSetupAccounts'
  }
</script>
